var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      attrs: { placement: "bottom", width: "800", trigger: "click" },
      on: { show: _vm.handleChangeList },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "pop-up-box",
        },
        [
          _c("div", { staticClass: "popover-main" }, [
            _c("div", { staticClass: "popover-title" }, [
              _c("span", [_vm._v(_vm._s(_vm.fieldData["fieldName"]))]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "popover-content" },
              [
                _c(
                  "el-table",
                  {
                    attrs: {
                      data: _vm.data,
                      size: "mini",
                      "header-cell-style": {
                        background: "rgba(245,247,250,1)",
                      },
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { property: "stateName", label: "审批结果" },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { property: "reasonName", label: "不通过原因" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    scope.row.reasonName !== null
                                      ? scope.row.reasonName
                                      : ""
                                  ) +
                                  "\n            "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        property: "approveSuggestion",
                        label: "审批意见",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    scope.row.approveSuggestion
                                  ),
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { property: "createName", label: "操作人" },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { property: "createDate", label: "操作时间" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "span",
        {
          staticStyle: {
            "margin-right": "5px",
            "text-decoration": "underline",
            cursor: "pointer",
            color: "#ff8850",
          },
          attrs: { slot: "reference" },
          slot: "reference",
        },
        [_vm._v(_vm._s(_vm.rowData["approveResultMsg"]))]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }